<template>
  <div>
    <ShopTracking
      :toggle-value="tracking.tiktokEnabled"
      :tracking-id-value="tracking.tiktokPixelId"
      toggle-label="TikTok Pixel"
      paragraph-text="POS.SHOP_SETTINGS.PINTEREST_MKT.TRACKING_PARAGRAPH"
      input-label="TikTok Pixel"
      :smart-faq-link="smartFaqLink"
      regex="^[A-Za-z0-9]+$"
      @toggle-input="tracking.tiktokEnabled = $event"
      @tracking-id-input="tracking.tiktokPixelId = $event"
    />
  </div>
</template>

<script>
import { TrackingData } from 'src/app/partnerarea/pos/shop/shopSavable/TrackingData';
import ShopTracking from './ShopTracking.vue';
import smartFaqLinks from 'commons/smartFaq/smartFaqLinks';

export default {
  name: 'TikTokMarketing',
  components: {
    ShopTracking,
  },
  mixins: [TrackingData],
  data() {
    return {
      smartFaqLink: smartFaqLinks.TIKTOK_TRACKING_PIXEL,
    };
  },
  created() {
    this.$store.commit('shop/setLivePreview', { path: '' });
  },
};
</script>
